import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';

class NotAuthorized extends Component {
  render() {
    return(
      <s-container>
        <h1><LanguageStringResolver string='notAuthorized_NotAuthorized'/></h1>
        <button className="primary"><Link className="primary" to="/"><LanguageStringResolver string='notAuthorized_Home'/></Link></button>
      </s-container>
    );
  }
}

export default NotAuthorized;
